import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 25 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.125 12.429a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0M5 9.804a2.625 2.625 0 1 0 0 5.25 2.625 2.625 0 0 0 0-5.25m15 0a2.625 2.625 0 1 0 0 5.25 2.625 2.625 0 0 0 0-5.25"
    }, null, -1)
  ])))
}
export default { render: render }